import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { PipesModule } from '@usucampeao/utils-frontend';
import { CadastroStatusModule } from 'libs/ui-mobile/src/lib/components/cadastro-ficha-status/cadastro-status.module';
import { DatepickerModule, FooterModule, HeaderModule, InputModule, SelectModule } from '../../../../components';
import { ProprietariosDadosBasicosComponent } from './proprietarios-dados-basicos.component';

@NgModule({
  declarations: [
    ProprietariosDadosBasicosComponent
  ],
  imports: [
    // root
    CommonModule,
    IonicModule,
    ReactiveFormsModule,

    // components
    CadastroStatusModule,
    FooterModule,
    HeaderModule,
    InputModule,
    DatepickerModule,
    SelectModule,

    // others
    PipesModule,
  ],
  exports: [
    ProprietariosDadosBasicosComponent
  ]
})
export class ProprietariosDadosBasicosModule { }
